import React from 'react';
import { Section } from '@fiverr-private/layout_components';
import { HeroSection } from '../HeroSection';
import { IntroSection } from '../IntroSection';
import { TestimonialsSection } from '../TestimonialsSection';
import { OurValuesSection } from '../OurValuesSection';
import { OfficesSection } from '../OfficesSection';
import { OpenPositionsSection } from '../OpenPositionsSection';
import { UnusualWaySection } from '../UnusualWaySection';
import { Job } from '../../../lib/comeet';
import { FilterValues } from '../../../lib/filters';
import { CvMatchProvider } from '../../lib/cvMatch';
import { TurnstileProvider } from '../../lib/turnstile';
import type { Testimonial } from '../../../server/data/testimonials';

export interface CareersPageProps {
    comeetPositions: Job[];
    initialFilters?: FilterValues;
    testimonials: Testimonial[];
    isBlockedCountry: boolean;
    /** Cloudflare Turnstile public site key; null → captcha disabled (local dev). */
    turnstileSiteKey?: string | null;
}

export const CareersPage = ({
    comeetPositions,
    initialFilters,
    testimonials,
    isBlockedCountry,
    turnstileSiteKey,
}: CareersPageProps) => (
    <Section
        fullWidth
        backgroundColor="white"
        style={{
            color: '#0c0c0d',
            overflowX: 'clip',
            maxWidth: '1440px',
        }}
    >
        <TurnstileProvider siteKey={turnstileSiteKey}>
            <CvMatchProvider comeetPositions={!isBlockedCountry ? comeetPositions : []}>
                <HeroSection />
                <IntroSection />
                <TestimonialsSection testimonials={testimonials} />
                <OurValuesSection />
                <OfficesSection />
                <OpenPositionsSection
                    comeetPositions={!isBlockedCountry ? comeetPositions : []}
                    initialFilters={initialFilters}
                />
                {!isBlockedCountry && <UnusualWaySection />}
            </CvMatchProvider>
        </TurnstileProvider>
    </Section>
);
